import React, { ChangeEvent, useContext, useEffect, useState } from 'react'
import { uniqBy } from 'lodash'
import { Button, Collapse, Input, Space, Table } from 'antd'
import styled from 'styled-components'
import { ColumnsType } from 'antd/es/table'
import { AuthContext } from '../../context/AuthProvider'
import { NETWORKS } from '../../helpers/chains'

const { Panel } = Collapse

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10vw;
  overflow: auto;
  padding-bottom: 80px;
`
const SearchContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 30%;
  align-self: flex-end;
  margin-bottom: 20px;
`

interface DataType {
  key: string
  number: number
  validator: string
  ev: IValidatorInfo
  explorerUrl: string
}
export interface IValidatorInfo {
  pubkeys: string
  ev: Ev
}
export interface Ev {
  blockNumber: number
  blockHash: string
  transactionIndex: number
  removed: boolean
  address: string
  data: string
  topics: string[]
  transactionHash: string
  logIndex: number
  event: string
  eventSignature: string
  args: string[]
}

const columns: ColumnsType<DataType> = [
  {
    title: '#',
    dataIndex: 'number',
    key: 'number',
  },
  {
    title: 'Validators',
    dataIndex: 'validator',
    key: 'validator',
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record: any) => {
      return (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              navigator.clipboard.writeText(record.validator)
            }}
          >
            Copy
          </Button>
          <a
            href={`${record.explorerUrl}/tx/${record.ev.transactionHash}`}
            target="_blank"
            rel="noreferrer"
          >
            Visit
          </a>
        </Space>
      )
    },
  },
]

const dataCreator = (
  dataSource: IValidatorInfo,
  explorerUrl: string
): DataType[] => {
  const validatorPublikKeys = dataSource.pubkeys.slice(2).match(/.{1,96}/g)
  return validatorPublikKeys.map((pKey: string, index: number) => {
    return {
      key: pKey,
      number: index + 1,
      validator: pKey,
      ev: dataSource,
      explorerUrl,
    }
  })
}

export const Validators = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [validators, setValidators] = useState([])
  const { userData } = useContext(AuthContext)
  // @ts-ignore
  const explorerUrl = NETWORKS[userData.chainId].blockExplorerUrl
  useEffect(() => {
    if (
      userData &&
      localStorage.getItem(`${userData.address}-${userData.chainId}`)
    ) {
      const lsItems = JSON.parse(
        localStorage.getItem(`${userData.address}-${userData.chainId}`)
      )
      if (lsItems) {
        setValidators(uniqBy(lsItems, 'transactionHash'))
      }
    }
  }, [userData])

  const changeSearchTermValue = (ev: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(ev.target.value)
  }

  return (
    <AppContainer>
      <SearchContainer>
        <Input.Group compact style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Input
            value={searchTerm}
            onChange={changeSearchTermValue}
            placeholder="Enter transaction hash"
          />
        </Input.Group>
      </SearchContainer>

      {validators.length ? (
        validators
          .filter((el) => el.transactionHash.includes(searchTerm))
          .map((validator) => {
            return (
              <Collapse defaultActiveKey={['1']} style={{ width: '100%' }}>
                {/* eslint-disable-next-line react/no-array-index-key */}
                <Panel
                  header={validator.transactionHash}
                  key={validator.transactionHash}
                >
                  <Table
                    columns={columns}
                    dataSource={dataCreator(validator, explorerUrl)}
                  />
                </Panel>
              </Collapse>
            )
          })
      ) : (
        <div style={{ textAlign: 'center' }}>No Validators created</div>
      )}
    </AppContainer>
  )
}
